import React from 'react';
import { useSelector } from 'react-redux';
import Layout from './site/layout';
import AdminLayout from './admin/layout';
import { ADMIN_ROLE } from 'config/constants';
import { Route, Redirect } from 'react-router-dom';

// import { Container } from './styles';

export function RouteManager({ component: Component, ...rest }) {
  //Busca usuario logado
  const user = useSelector(state => state.user);
  const token = user && user.calendar_token ? true : false;
  const userId = user && user.id ? user.id : null;

  //Verifica se rota é para admin e se caso não exista usuário logado redireciona

  if (window.location.href.includes('admin') && !user) {
    return <Redirect to="/" />;
  }
  const isAdmin =
    user && user.roles ? user.roles.filter(u => u.name === ADMIN_ROLE) : [];
  if (window.location.href.includes('admin') && user && isAdmin.length > 0) {
    return (
      <Route
        {...rest}
        render={matchProps => (
          <AdminLayout {...matchProps} props>
            <Component {...matchProps} />
          </AdminLayout>
        )}
      />
    );
  }

  return (
    <Route
      {...rest}
      render={matchProps => (
        <Layout {...matchProps} isAdmin={isAdmin.length > 0}>
          <Component
            {...matchProps}
            user={user ? true : false}
            userId={userId}
            token={token}
          />
        </Layout>
      )}
    />
  );
}
